import { Controller } from '@hotwired/stimulus'
import store from '../store'
import { provisions as provisionsSignal } from '../section-fragments-store'

const orderedSectionSqids = Array.from(document.querySelectorAll('.section')).map(s => s.dataset.sectionSqid)

export default class extends Controller {
  static targets = [ "previousBtn", "nextBtn" ]

  connect() {
    this.previousBtnTarget.disabled = true
    this.effects = [
      store.selectedProvision.effect(() => {
        if(store.selectedProvision.value && store.selectedProvision.value.provisionSqid) {
          const { previous, next } = getProvisionsByCurrentProvision(store.selectedProvision.value.provisionSqid, provisionsSignal.value)
          this.previousBtnTarget.disabled = !previous
          this.nextBtnTarget.disabled = !next
        }
      }),
      store.selectedSectionSqid.effect(() => {
        if(store.selectedSectionSqid.value) {
          const { previous, next } = getProvisionsByCurrentSection(store.selectedSectionSqid.value, provisionsSignal.value)
          this.previousBtnTarget.disabled = !previous
          this.nextBtnTarget.disabled = !next
        }
      })
    ]
  }
  
  disconnect() {
    this.effects.forEach(dispose => dispose())
  }

  previous() {
    let previous = null
    if(store.selectedProvision.value && store.selectedProvision.value.provisionSqid) {
      ({ previous } = getProvisionsByCurrentProvision(store.selectedProvision.value.provisionSqid, provisionsSignal.value))
    } else if(store.selectedSectionSqid.value) {
      ({ previous } = getProvisionsByCurrentSection(store.selectedSectionSqid.value, provisionsSignal.value))
    }
    navigateToProvision(previous)
  }

  next() {
    let next = null
    if(store.selectedProvision.value && store.selectedProvision.value.provisionSqid) {
      ({ next } = getProvisionsByCurrentProvision(store.selectedProvision.value.provisionSqid, provisionsSignal.value))
    } else if(store.selectedSectionSqid.value) {
      ({ next } = getProvisionsByCurrentSection(store.selectedSectionSqid.value, provisionsSignal.value))
    } else {
      next = provisionsSignal.value[0]
    }
    navigateToProvision(next)
  }
}

const getProvisionsByCurrentProvision = (provisionSqid, provisions) => {
  const provision = provisions.find(p => p.provisionSqid === provisionSqid)
  const provisionIndex = provisions.indexOf(provision)
  const previous = provisionIndex > 0 ? provisions[provisionIndex - 1] : null
  const next = provisionIndex < provisions.length - 1 ? provisions[provisionIndex + 1] : null
  return { previous, next }
}

const getProvisionsByCurrentSection = (sectionSqid, provisions) => {
  const sectionIndex = orderedSectionSqids.indexOf(sectionSqid)
  const sectionSqidsToConsiderForPrevious = orderedSectionSqids.slice(0, sectionIndex)
  const previous = provisions.toReversed().find(p => sectionSqidsToConsiderForPrevious.indexOf(p.sectionSqid) >= 0)
  const sectionSqidsToConsiderForNext = orderedSectionSqids.slice(sectionIndex)
  const next = provisions.find(p => sectionSqidsToConsiderForNext.indexOf(p.sectionSqid) >= 0)
  return { previous, next }
}

const navigateToProvision = (provision) => {
  if(provision) {
    store.selectedProvision.set(provision)
    if(provision.fragmentIds[0]) {
      const firstFragment = document.getElementById(provision.fragmentIds[0])
      if(firstFragment) {
        firstFragment.scrollIntoView({ block: "center" })
      }
    }
    document.getElementById(`provision-${provision.provisionSqid}-accordion-item`).scrollIntoView()
    document.getElementById(`toc-link-${provision.sectionSqid}`).scrollIntoView()
  }
}